import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cep',
  pure: false,
  standalone: true,
})
export class CepPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/(\d{2})(\d{3})(\d{3})/, '($1) $2-$3');
  }
}
